import dateRange from './dateRange.vue'

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.dateRange = function (dateRangeObj, opts) {
        // if (!vueInstance) {
        let el = document.createElement('div')
        document.querySelector('body').appendChild(el)

        let vueClass = Vue.extend(dateRange);

        vueInstance = new vueClass({
            el: el,
            router: opt.router
        })
        // }

        vueInstance.wrapshow = true
        return vueInstance.showPicker(dateRangeObj, opts)
    }
}


export default Plugin;
